import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  introText: {
    margin: theme.spacing(2, 0),
    color: theme.palette.text.secondary,
  },
  pageContainer: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
    backgroundColor: '#02CBF5',
    padding: theme.spacing(2),
    marginInlineStart: 0,
    color: 'white',
  },
  logo: {
    height: '30px',
    marginRight: theme.spacing(2),
  },
  headerText: {
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: '3vw',
    },
    marginTop: '10px',
  },
  card: {
    marginBottom: 10,
    borderRadius: 20,
    border: '1px solid rgba(0, 0, 0, 0.2)',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
    width: '100%',
    minHeight: '350px',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  },
  divider: {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    margin: '10px 0',
  },
  verticalDivider: {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    height: '100%',
    margin: '0 10px',
    minHeight: '40px',
  },
  cardHeader: {
    backgroundColor: '#02CBF5',
    color: '#fff',
    textAlign: 'center',
  },
  premiumChip: {
    minWidth: '160px',
    background: '#02CBF4',
    color: '#fff',
    fontWeight: 'bold',
  },
  estandarChip: {
    minWidth: '160px',
    background: '#2196f3',
    color: '#fff',
    fontWeight: 'bold',
  },
  basicChip: {
    minWidth: '160px',
    background: '#9e9e9e',
    color: '#fff',
    fontWeight: 'bold',
  },
  noClassChip: {
    minWidth: '160px',
    background: '#ffff',
    color: '#000',
    fontWeight: 'bold',
  },
  chipContainer: {
    textAlign: 'center',
    marginTop: '2px',
  },
}));
